import history from "./utils/history";
import { AppState } from "@auth0/auth0-react";
import { QueryClient } from "react-query";

export const ENV = process.env.REACT_APP_ENVIRONMENT || "local";

export function getConfig() {
  const authConfig = {
    domain: process.env.REACT_APP_DOMAIN || "",
    clientId: process.env.REACT_APP_CLIENT_ID || "",
    audience: process.env.REACT_APP_AUDIENCE || "",
  };

  const audience =
    authConfig.audience && authConfig.audience !== "YOUR_API_IDENTIFIER"
      ? authConfig.audience
      : null;

  if (!authConfig.audience || !authConfig.clientId || !authConfig.domain) {
    throw new Error("[GeneralConfig]: Auth0 Configuration is missing");
  }

  return {
    domain: authConfig.domain,
    clientId: authConfig.clientId,

    ...(audience ? { audience } : null),
  };
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const onRedirectCallback: (appState?: AppState | undefined) => void = (
  appState?: AppState
) => {
  let historyPath =
    appState && appState.returnTo
      ? appState.returnTo
      : window.location.pathname;

  if (window.location.hash !== "") {
    historyPath = `${window.location.origin}${window.location.hash}`;
  }
  history.push(historyPath);
};

export function getAuth0ProviderConfig(window: any) {
  const config = getConfig();
  return {
    domain: config.domain,
    clientId: config.clientId,
    ...(config.audience ? { audience: config.audience } : null),
    redirectUri: window.location.origin,
    onRedirectCallback: onRedirectCallback,
    useRefreshTokens: true,
  };
}
